<template>
  <section class="activity_dialog">
    <div class="activity">
      <p class="title">{{$t('global.选择发布类型')}}</p>
      <div class="article" :class="{active:step == 1}" @click="changeActive(1)">
        <span>{{$t('global.线下活动')}}</span>{{$t('global.展览')}}、{{$t('global.演出')}}、{{$t('global.论坛等')}}
      </div>
      <div class="article" :class="{active:step == 2}" @click="changeActive(2)">
        <span>{{$t('global.线上活动')}}</span>{{$t('global.作品征集等')}}
      </div>
      <div class="article" :class="{active:step == 3}" @click="changeActive(3)">
        <span>{{$t('global.竞赛')}}</span>
      </div>
      <a class="cancel" href="javascript:;" @click.prevent="closepopus">{{$t('global.取消')}}</a>
      <a class="submit" href="javascript:;" @click.prevent="navTo">{{$t('global.确定')}}</a>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      step: null,
      userType: "",
      isCertification: false
    };
  },
  props: [close],
  methods: {
    closepopus() {
      this.$emit("close");
      document.body.style.overflow = "";
    },
    changeActive(step) {
      this.step = step;
    },
    navTo() {
      if (this.step) {
        if(this.step == 3) {
          window.location = "http://manabang.mikecrm.com/WZl9NT3";
        } 
        if (this.step == 2) {
          this.$router.push("/ActivityLunch");
        }
        if (this.step == 1) {
          this.$router.push("/newActivityLunch");
        }
      }else{
         this.$message.error(this.$t('global.请选择发布类型'));
      }
    }
  },

  created() {
    // if (localStorage.getItem("auth_token")) {
    //   this.$http.get("/api/u/info/get").then(response => {
    //     let data = response.data;
    //     this.userType = data.userType;
    //     if (data.isCertification == 1) {
    //       this.isCertification = true;
    //     }
    //     if (data.isCertification == 2) {
    //       this.isCertification = false;
    //     }
    //   });
    // }
  }
};
</script>

<style lang="css" scoped>
.activity_dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  z-index: 111;
}
.activity_dialog .activity {
  width: 428px;
  height: 450px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  border-radius: 10px;
}

.activity_dialog .activity .title {
  color: #333;
  font-size: 20px;
  width: 428px;
  text-align: center;
  margin-top: 30px;
}
.activity_dialog .activity .article {
  width: 358px;
  height: 63px;
  color: #999;
  font-size: 14px;
  line-height: 63px;
  border-radius: 5px;
  margin: 29px auto 0;
  cursor: pointer;
  border: 1px solid rgba(221, 221, 221, 1);
}
.activity_dialog .activity .article.active {
  color: #43c0bd;
  border: 1px solid rgba(67, 192, 189, 1);
}
.activity_dialog .activity .article span {
  font-size: 24px;
  font-weight: bold;
  margin: 0 20px;
}

.activity_dialog .activity .cancel {
  display: inline-block;
  width: 100px;
  height: 40px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  border-radius: 5px;
  cursor: pointer;
  margin: 44px 20px 0 104px;
  background: rgba(202, 202, 202, 1);
}

.activity_dialog .activity .submit {
  display: inline-block;
  width: 100px;
  height: 40px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 44px;
  background-color: #4a90e2;
}
</style>




// WEBPACK FOOTER //
// src/pages/dialog/ActivityDialog.vue